export const configureTagKeys = {
  all: ['configure-tags'] as const,
  one: (id: number) => [...configureTagKeys.all, 'detail', id] as const,
};
